import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {useString} from '../../../utils/string'
import {apiGetKeyPortfolio} from '../../../apis/user/getKeyProfile'

const useQueryUserKeyDetail = (keyId?: string) => {
    const {isNotEmpty} = useString()

    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.user.getKeyProfile(keyId),
        queryFn: async () => {
            const {data} = await apiGetKeyPortfolio(keyId)
            return data
        },
        refetchOnWindowFocus: false,
        enabled: isNotEmpty(keyId),
    })

    return {data, refetch, isLoading}
}

export default useQueryUserKeyDetail
